import styled from '@emotion/styled'

import { Link } from 'react-router-dom'

import { colors, metrics } from 'component-library/__styling/settings'
import { calcRem } from 'component-library/__styling/style-functions'

import { conditionalStyles } from 'component-library/__styling/conditional-styles'
import { themedValue } from 'component-library/__styling/themed-value'

export const StyledTag = styled(Link)(
    {
        border: '1px solid transparent',
        display: 'inline-block',
        textDecoration: 'none',
        transition: 'background 250ms ease, transform 150ms ease',

        '&:hover, &:focus': {
            WebkitTapHighlightColor: 'transparent',
        },

        '&:focus': {
            outline: 'none',
        },
    },
    props => ({
        background: themedValue(props.theme, {
            thewest: colors.thewest.greyMouse,
            perthnow: colors.perthnow.greyMarble,
            sevennews: colors.sevennews.seashell,
        }),
        color: themedValue(props.theme, {
            thewest: colors.thewest.greyElephant,
            perthnow: colors.black,
            sevennews: colors.sevennews.charade,
        }),
        fontFamily: props.theme.fonts.sansSerif,
        fontSize: themedValue(props.theme, {
            perthnow: calcRem(13),
            thewest: calcRem(14),
            sevennews: calcRem(12),
        }),
        fontWeight: themedValue(props.theme, { perthnow: 700, thewest: 400, sevennews: 500 }),
        margin: themedValue(props.theme, {
            perthnow: calcRem(0, 9, 9, 0),
            fallback: `0 ${calcRem(metrics.globalMargin / 2)} ${calcRem(
                metrics.globalMargin / 2
            )} 0`,
        }),
        padding: themedValue(props.theme, {
            perthnow: calcRem(1.5, 9),
            thewest: calcRem(5, 12),
            sevennews: calcRem(5, 15),
        }),

        ...conditionalStyles(props.theme.kind === 'sevennews', {
            borderRadius: calcRem(18),

            '&:hover': {
                color: colors.white,
                background: themedValue(props.theme, {
                    sevennews: section => section.tag.primaryColor,
                    fallback: undefined,
                }),
            },

            '&:focus': {
                color: colors.white,
                background: themedValue(props.theme, {
                    sevennews: section => section.tag.primaryColor,
                    fallback: undefined,
                }),
                textDecoration: 'underline',
            },

            '&:active': {
                color: colors.sevennews.stormGrey,
            },
        }),

        ...conditionalStyles(props.theme.kind === 'thewest', {
            borderRadius: calcRem(18),

            '&:hover': {
                color: props.theme.sectionValues.primaryColor,
            },

            '&:focus': {
                color: props.theme.sectionValues.primaryColor,
                textDecoration: 'underline',
            },

            '&:active': {
                color: colors.thewest.greyGorilla,
            },
        }),

        ...conditionalStyles(props.theme.kind === 'perthnow', {
            border: '1px solid transparent',
            lineHeight: calcRem(13),

            '&:hover': {
                borderRadius: calcRem(2),
                background: colors.perthnow.greyMoonstone,
                color: colors.white,
            },

            '&:focus': {
                background: colors.white,
                border: `1px solid ${colors.black}`,
                color: colors.black,
            },

            '&:active': {
                background: colors.perthnow.greyMoonstone,
                color: colors.white,
                transform: 'none',
            },
        }),
    })
)
